// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"661":"e201550a","787":"054b66e3"}[chunkId] + ".chunk.js";
};